export const FeatureFlags = {
  NEXT_GENERATION_LISTING_MANAGEMENT: 'next_generation_listing_management',
  CREATE_PROPERTY_TYPE_FILTER: 'ngw_create_property_type_filter',
  CREATE_SUB_PROPERTY_TYPE_FILTER: 'ngw_create_sub_property_type_filter',
  DEBUG: 'ngw_debug',
  NGW_AI_CONFIDENCE_SOURCE: 'ngw_ai_confidence_score',
  NGW_AI_IMAGE_DESCRIPTIONS: 'ngw_ai_image_descriptions',
  NGW_MEDIA_SCROLL_OFFSET: 'ngw_media_scroll_offset',
  NGW_MEDIA_POLLING: 'ngw_media_polling',
  NGW_EMAIL: 'ngw_email',
  NGW_EMAIL_SELLING_AGENT: 'ngw_email_selling_agent',
  NGW_ENROLLMENT: 'ngw_enrollment',
  NGW_BACK_TO_LEGACY: 'ngw_back_to_legacy',
  NGW_MEDIA_DEBUG: 'ngw_media_debug',
  NGW_MEDIA_V2: 'ngw_media_v2',
  NGW_INTAKE_FORM: 'ngw_intake_form',
  NGW_SHOW_INIT_MODAL: 'ngw_show_init_modal',
  NGW_CREATE_WITHOUT_TAX_RECORD: 'ngw_create_without_tax_record',
  NGW_CONFETTI: 'ngw_confetti',
  NGW_CONFIG_OVERRIDE: 'ngw_config_override',
  NGW_MEDIA: 'ngw_media',
  NGW_PUBLISH: 'ngw_publish',
  NGW_PREVIEW_DRAFT: 'ngw_preview_draft',
  NGW_SHARE_DRAFT: 'ngw_share_draft',
  RESO_AUTH: 'ngw_reso_auth',
  REMOVE_FROM_LISTING_DATA: 'ngw_remove_from_listing_data',
  REMOVE_FROM_TAX_DATA: 'ngw_remove_from_tax_data',
  NGW_ANALYTICS: 'ngw_view_analytics',
  NGW_ADMIN: 'ngw_admin',
  NGW_NEW_MULTI_SELECT: 'ngw_new_multi_select',
  NGW_NEW_LEVELS_AND_ROOMS: 'ngw_new_levels_and_rooms',
  NGW_DEBUG_CREATE: 'ngw_debug_create',
  NGW_CREATE_DETECTED_LISTING_FEATURES: 'ngw_create_detected_listing_features',
  NGW_DEBUG_EDIT: 'ngw_debug_edit',
  NGW_EDIT_REDESIGN: 'ngw_edit_redesign',
  NGW_OBJECT_DETECTION: 'ngw_object_detection',
  NGW_MEDIA_CLOUD_UPLOADS: 'ngw_media_cloud_uploads',
  NGW_MEDIA_CLOUD_PROVIDER_DROPBOX: 'ngw_media_cloud_provider_dropbox',
  NGW_MEDIA_CLOUD_PROVIDER_GOOGLE: 'ngw_media_cloud_provider_google_drive',
  NGW_MEDIA_CLOUD_PROVIDER_ONEDRIVE: 'ngw_media_cloud_provider_onedrive',
  NGW_USE_WEBSOCKETS: 'ngw_use_websockets',
  NGW_EDIT_IMAGE: 'ngw_edit_image',
  NGW_EDIT_IMAGE_CROP: 'ngw_edit_image_crop',
  NGW_EDIT_IMAGE_ROTATE: 'ngw_edit_image_rotate',
  NGW_EDIT_MEMBER_DEFAULTS: 'ngw_edit_member_defaults',
  NGW_EDIT_SIDEPANEL_REDESIGN: 'ngw_edit_sidepanel_redesign',
  NGW_SHOWING_CHOICE: 'ngw_showing_choice',
  NGW_MULTI_DRAG_DROP: 'ngw_media_multi_drag_drop',
  NGW_HEREMAPS_OPTIMIZATIONS: 'ngw_heremaps_optimizations',
  NGW_EDIT_YEAR_PICKER_REDESIGN: 'ngw_edit_year_picker_redesign',
  NGW_OFFER_MANAGEMENT: 'ngw_offer_management',
  NGW_MEDIA_FAILURE_MODAL: 'ngw_media_failure_modal',
  NGW_OVERVIEW: 'ngw_overview',
  NGW_USER_TERMS: 'ngw_user_terms',
  NGW_HIDE_MEDIA_OFF_MARKET: 'ngw_hide_media_off_market',
  NGW_OFFICE_EXCLUSIVE_DOC: 'ngw_office_exclusive_doc',
  NGW_OFFICE_EXCLUSIVE_DELETE_DOC: 'ngw_office_exclusive_delete_doc',
} as const;
